import { svg } from "config/svgStyles";

export const container = ({ isMobile }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: isMobile ? "flex-start" : "center",
  height: isMobile ? "auto" : "100%",
  width: "100%",
  position: "relative",
  padding: isMobile ? "20px 20px 140px 20px" : "0 40px",
});

export const heading = ({ isMobile }) => ({
  variant: isMobile ? "text.h5Light" : "text.h2Light",
  margin: 0,
  marginBottom: isMobile ? "20px" : "40px",
  position: "relative",
  zIndex: 20,
});

export const desktopHeading = ({ isMobile, labelTop, labelLeft }) => ({
  variant: isMobile ? "text.h5Light" : "text.h2Light",
  margin: 0,
  marginBottom: isMobile ? "20px" : "40px",
  position: "relative",
  zIndex: 20,
  top: labelTop,
  left: labelLeft,
});

export const cardsContainer = ({ isMobile }) => ({
  display: "flex",
  flexDirection: isMobile ? "column" : "row",
  width: "100%",
  justifyContent: "center",
  alignItems: isMobile ? "center" : "flex-start",
  padding: isMobile ? "0" : "0 10px",
  position: "relative",
  zIndex: 20,
  gap: "20px",
  flexWrap: "wrap",
});

export const desktopCardsContainer = ({ isMobile, containerTop }) => ({
  display: "flex",
  flexDirection: isMobile ? "column" : "row",
  width: "100%",
  justifyContent: "center",
  alignItems: isMobile ? "center" : "flex-start",
  padding: isMobile ? "0" : "0 10px",
  position: "relative",
  zIndex: 20,
  gap: "20px",
  flexWrap: "wrap",
  top: containerTop,
});

export const card = ({ isMobile }) => ({
  width: isMobile ? "100%" : "unset",
  minWidth: "220px",
  maxWidth: isMobile ? "320px" : "270px",
  minHeight: isMobile ? "164px" : "270px",
  flexGrow: 1,
  flexShrink: 1,
});

export const desktopCard = ({ isMobile, position, top, left, right }) => ({
  width: isMobile ? "100%" : "unset",
  minWidth: "220px",
  maxWidth: isMobile ? "320px" : "270px",
  minHeight: isMobile ? "164px" : "270px",
  flexGrow: 1,
  flexShrink: 1,

  "&:first-of-type": {
    position,
    top,
    right: left,
  },

  "&:nth-of-type(2)": {
    position,
    top,
    left: right,
  },
});

export const SizeButton = (theme) => ({
  background: "white",
  borderRadius: "8px",
  width: "100%",
  cursor: "pointer",
  padding: 0,
  textDecoration: "none",
  textAlign: "center",

  "&:focus": {
    outline: `solid 2px ${theme.colors.primary}`,
    outlineOffset: "2px",
  },
});

export const SizeButtonTitle = {
  background: "black",
  borderTopLeftRadius: "8px",
  borderTopRightRadius: "8px",
  color: "white",
  padding: "15px",
};

export const SizeButtonContent = {
  border: "1px solid",
  borderTop: "none",
  borderColor: "grey9",
  borderBottomLeftRadius: "8px",
  borderBottomRightRadius: "8px",
  padding: "40px",
  textAlign: "center",
  color: "black",
};

export const SizeButtonStartingAt = {
  mb: "20px",
  pb: "20px",
  borderBottom: "solid 1px",
  borderColor: "grey9",
  textAlign: "center",
};

export const changeStickButton = {
  color: "primary",
  mt: "20px",
  width: "100%",
  textAlign: "center",
  position: "relative",
  px: "20px",
  variant: "text.h5",
  textTransform: "uppercase",

  "> svg": {
    ...svg("primary"),
    position: "absolute",
    left: "0",
    top: "50%",
    transform: "translateY(-50%)",
  },
};

export const helpInfoGuidesContainer = ({ isMobile }) => ({
  display: "flex",
  flexDirection: !isMobile ? "row" : "column",
  position: "absolute",
  bottom: "0",
  paddingBottom: "40px",
  zIndex: "300",
  gap: isMobile ? "20px" : "30px",
});

export const helpInfoGuide = ({ isMobile }) => ({
  color: "primary",
  fontSize: !isMobile ? "30px" : "20px",
  letterSpacing: "0.025em",
  cursor: "pointer",
  position: "relative",
  textAlign: "center",
  background: "none",
  border: "none",

  ...(!isMobile
    ? {
        "&:last-of-type:after": {
          content: "''",
          borderLeft: "solid 2px",
          borderLeftColor: "grey7",
          position: "absolute",
          left: "-14px",
          height: "30px",
        },
      }
    : {}),
});
